import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { DefaultRoutes } from '../constants/routes/routes'

import PublicGuard from './PublicGuard'
import AuthGuard from './AuthGuard'
import RolesLoader from '../pages/RolesLoader'
import TwoFASetup from '../pages/TwoFASetup'
import TwoFAVerify from '../pages/TwoFAVerify'

function MainRouter() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public Route */}
        <Route path={DefaultRoutes.public.DEFAULT} element={<RolesLoader />} />

        <Route path={DefaultRoutes.public.LOGIN} element={<PublicGuard />} />

        {/* 2FA Routes */}
        <Route path={'/2fa-setup'} element={<TwoFASetup />} />
        <Route path={'/2fa-verify'} element={<TwoFAVerify />} />

        {/* Private Routes */}
        <Route
          path={`${DefaultRoutes.private.DEFAULT}${DefaultRoutes.any}`}
          element={<AuthGuard />}
          shouldRevalidate={true}
        />
        <Route
          path={DefaultRoutes.any}
          element={<Navigate to={`..${DefaultRoutes.public.DEFAULT}`} />}
        />
      </Routes>
    </BrowserRouter>
  )
}

export default MainRouter
